import { createTestListTypes } from '../../../common/test-list/types';

export const NAMESPACE = 'analytics-test-history-test-list-vdc';
export default createTestListTypes(NAMESPACE);
